import React from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Card, Button } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import { useSelector } from 'react-redux';

import SimpleMantenedorLayout from '../../components/SimpleMantenedorLayout';
import { useMantenedores } from '../../context/MantenedoresContext';

const Extras = () => {
  const history = useHistory();
  const user = useSelector(state => state.auth.user);
  const { userPermissions } = useMantenedores();
  const permisos = userPermissions?.modules?.extras || {};

  // Navegar a los submódulos
  const navigateToListaExtras = () => {
    history.push('/mantenedores/extras/lista');
  };

  const navigateToAsignaciones = () => {
    history.push('/mantenedores/extras/asignaciones');
  };

  return (
    <SimpleMantenedorLayout
      mantenedorId="extras"
      title="Mantenedor de Extras"
      subtitle="Gestión de extras y asignaciones a conductores"
      iconColor="#e53e3e"
      breadcrumbs={[{ label: 'Extras' }]}
      showBackButton={false}
    >
      <Row className="mt-4">
        <Col xs={12}>
          <div style={{ marginBottom: '24px' }}>
            <h4 style={{ color: '#212529', marginBottom: '8px' }}>
              Opciones de Extras
            </h4>
            <p style={{ color: '#6c757d', marginBottom: '0' }}>
              Selecciona el tipo de gestión que deseas realizar
            </p>
          </div>
        </Col>
      </Row>

      <Row className="g-4">
        {/* Submódulo Lista de Extras */}
        <Col xs={12} md={6}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToListaExtras : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#ffeaa7',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaGift 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#e17055' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Lista de Extras
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Gestiona el catálogo de extras disponibles: bonos, descuentos, pérdidas y otros tipos de extras
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-warning"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToListaExtras();
                  }}
                >
                  <FaIcons.FaList className="me-2" />
                  Ver Extras
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Submódulo Asignación de Extras */}
        <Col xs={12} md={6}>
          <Card 
            className="h-100 shadow-sm border-0"
            style={{ 
              cursor: permisos.canView ? 'pointer' : 'not-allowed',
              opacity: permisos.canView ? 1 : 0.6,
              transition: 'all 0.3s ease'
            }}
            onClick={permisos.canView ? navigateToAsignaciones : undefined}
          >
            <Card.Body className="d-flex flex-column align-items-center text-center p-4">
              <div 
                style={{
                  width: '80px',
                  height: '80px',
                  borderRadius: '50%',
                  backgroundColor: '#81ecec',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px'
                }}
              >
                <FaIcons.FaUserPlus 
                  style={{ 
                    fontSize: '2rem', 
                    color: '#00b894' 
                  }} 
                />
              </div>
              
              <h5 style={{ color: '#212529', marginBottom: '12px' }}>
                Asignación a Conductores
              </h5>
              
              <p style={{ 
                color: '#6c757d', 
                marginBottom: '20px',
                fontSize: '0.95rem',
                lineHeight: '1.5'
              }}>
                Asigna extras específicos a conductores, rutas o guías individuales
              </p>
              
              <div className="mt-auto">
                <Button
                  variant="outline-success"
                  size="sm"
                  disabled={!permisos.canView}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (permisos.canView) navigateToAsignaciones();
                  }}
                >
                  <FaIcons.FaUserPlus className="me-2" />
                  Gestionar Asignaciones
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Información adicional */}
      <Row className="mt-5">
        <Col xs={12}>
          <Card className="border-0 bg-light">
            <Card.Body className="p-4">
              <Row>
                <Col xs={12} md={8}>
                  <h6 style={{ color: '#495057', marginBottom: '12px' }}>
                    <FaIcons.FaInfoCircle className="me-2" style={{ color: '#17a2b8' }} />
                    Información del Módulo de Extras
                  </h6>
                  <p style={{ color: '#6c757d', marginBottom: '0', fontSize: '0.9rem' }}>
                    Este módulo permite gestionar el catálogo completo de extras (bonos, descuentos, pérdidas) 
                    y asignarlos específicamente a conductores, rutas o guías individuales. Los extras asignados 
                    se incluirán automáticamente en los cierres mensuales.
                  </p>
                </Col>
                <Col xs={12} md={4} className="d-flex align-items-center justify-content-md-end mt-3 mt-md-0">
                  <div style={{ fontSize: '0.85rem', color: '#6c757d' }}>
                    <div><strong>Permisos actuales:</strong></div>
                    <div>Vista: {permisos.canView ? '✓' : '✗'}</div>
                    <div>Admin: {permisos.canAdmin ? '✓' : '✗'}</div>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </SimpleMantenedorLayout>
  );
};

export default Extras;
